import Cookies from 'js-cookie';

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  websocketStatus: '',
  size: Cookies.get('size') || 'medium',
  activeInjured: '0', // 人伤直赔数
  selecaData: null, // 医院，保险，拖修车等下拉列表
  isInviter: '', // 邀请名称
  invitRole: '', // 邀请角色
  searchCondition: {}, //搜索的条件
  videoType: 0, // 视频类型，1是5G
  videoPhone:'', // 5g电话号
  isHangupP:false, // 是否挂断过5g通过了
  inviteRequest5G: false, // 是否5g视频通话邀请
  invite5GId: '', // 5g视频邀请事故id
  mediationTabName:'',
};

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1);
    } else {
      Cookies.set('sidebarStatus', 0);
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0);
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device;
  },
  SET_SIZE: (state, size) => {
    state.size = size;
    Cookies.set('size', size);
  },
  SET_ACTIVEINJURED: (state, data) =>{
    state.activeInjured = data;
  },
  SET_SELECTDATA: (state, data) => {
    state.selecaData = data;
  },
  SET_ISINVITER: (state, data) => {
    state.InviteName = data.InviteName;
    state.invitRole = data.invitRole;
  },
  SET_SEARCHCONDITION: (state, data) => {
    state.searchCondition = data
  },
  SET_VIDEODATA: (state, data) => {
    state.videoType = data.type;
    state.videoPhone = data && data.phone ? data.phone : state.videoPhone;
  },
  SET_ISHANGUP: (state, data) => {
    state.isHangupP = data
  },
  INVITEREQUEST5G:(state, data) => {
    state.invite5GId = data.invite5GId ? data.invite5GId : state.invite5GId;
    state.inviteRequest5G = data.inviteRequest5G ? data.inviteRequest5G: state.inviteRequest5G;
  },
  SET_MEDIATIONTABNAME: (state, data) => {
    state.mediationTabName = data
  },
};

const actions = {
  toggleSideBar({commit}) {
    commit('TOGGLE_SIDEBAR');
  },
  closeSideBar({commit}, {withoutAnimation}) {
    commit('CLOSE_SIDEBAR', withoutAnimation);
  },
  toggleDevice({commit}, device) {
    commit('TOGGLE_DEVICE', device);
  },
  setSize({commit}, size) {
    commit('SET_SIZE', size);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
